import { render, staticRenderFns } from "./plat-form-select.vue?vue&type=template&id=15127d3e&"
import script from "./plat-form-select.vue?vue&type=script&lang=js&"
export * from "./plat-form-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "plat-form-select.vue"
export default component.exports